// Import CSS
import "./NotFound.css"

function NotFound() {
    return (
        <div className="not-found-page">
            <h1>404 NOT FOUND</h1>
        </div>
    )
}

export default NotFound